module.exports = __webpack_public_path__ + "static/media/message--dark.ad1f527b.png";